export const fishSoup = {
  id: "fishSoup",
  link: "/#/recipes/recipes/fishSoup",
  name: "Purelaker Fish Soup",
  cuisine: "Purelaker",
  summary: "A thin soup made with coconut milk and fish",
  inspiration: "Sua I'a",
  quantity: "4 servings",
  time: "1 hour",
  notes:
    "We don't know much more about Purelake fish soup other than that it's a soup with small fish in it. I looked to Polynesian food and found Sua I'a. The biggest difference here is that small fish are used. I chose to use fresh hot peppers rather than gochugaru like many of the other recipes because this dish comes from a very different cuisine than Alethi food.",
  quotes:
    "Maib stood inside, fixing a pot of fish soup (The Way of Kings Interlude I-1)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/fish-soup-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "smelts",
          display: "1/2 lb smelts"
        },
        {
          item: "water",
          display: "2 quarts water"
        },
        {
          item: "onion",
          display: "1 onion"
        },
        {
          item: "hotPeppers",
          display: "1 hot pepper, such as serrano or jalapeño"
        },
        {
          item: "salt",
          display: "1/2 tbsp salt"
        },
        {
          item: "coconut",
          display: "3/4 cup coconut milk"
        }
      ]
    }
  ],
  steps: [
    "Defrost smelts, if frozen. Clean them by cutting just behind the head, starting from the top but not cutting all the way through. Pull the head off - it should pull the innards out with it. Discard the head and innards. Repeat with all smelts. Rinse them.",
    "Boil 2 quarts of water in a pot. Chop the onion. Slice the pepper in half lengthwise, and remove the seeds if desired to make it less spicy. Thinly slice the pepper. Add the pepper, onion, and salt to the boiling water. Bring to a boil over high heat, then reduce heat and simmer for five minutes.",
    "Add the smelts to the pot along with the coconut milk. Increase heat to high until it comes to a boil, then reduce heat again to simmer. Cook for 15 minutes. Taste the broth - if it's still too watery, simmer a bit longer. Serve hot."
  ]
}
